Alpine.data('mediaModal', mediaModal);

export default function mediaModal(imported) {
	return {
		currentMediaIndex: 0,
		loading: false,
		media: imported.media,
		mediaCount: imported.media ? imported.media.length : 0,
		scrollPosition: 0,

		loadImage() {
			this.$nextTick(() => {
				const parent = this.$refs.imgContainer;

				if (this.$refs.modalImage !== undefined) {
					this.$refs.modalImage.remove();
				}

				if (this.media[this.currentMediaIndex].file_type === 'i') {
					const newImg = document.createElement('img');
					newImg.src = this.media[this.currentMediaIndex].modalSrc;
					newImg.srcset = this.media[this.currentMediaIndex].modalSrcset;
					newImg.alt = 'Review attachment';
					newImg.className = 'max-h-[90lvh] max-w-[90lvw] aspect-auto rounded-xl w-fit';
					newImg.setAttribute('x-ref', 'modalImage');
					newImg.setAttribute('x-on:load', 'loading = false');
					newImg.setAttribute('x-show', '!loading');

					parent.appendChild(newImg);
					this.$refs.modalImage = newImg;
				}
			});
		},

		next() {
			this.currentMediaIndex = (parseInt(this.currentMediaIndex) + 1) % this.mediaCount;

			if (this.media[this.currentMediaIndex].file_type === 'i') {
				this.loading = true;
				this.loadImage(this.currentMediaIndex);
			}
		},

		openModal(event) {
			this.scrollPosition = window.scrollY;
			this.loading = true;

			const target = event.target;
			this.currentMediaIndex = target.dataset.mediaIndex;

			if (this.media[this.currentMediaIndex].file_type === 'i') {
				this.loadImage();
			}

			this.$refs.mediaModal.showModal();
			this.$refs.mediaModal.blur();

			// Some interaction between Alpine and Livewire is resetting the scroll position and jumping to the top of the
			// page when the modal is opened after traversing review pages. This is a workaround to hold the correct page position.
			window.scrollTo({
				top: this.scrollPosition,
				left: 0,
				behavior: 'instant',
			});
		},

		prev() {
			this.currentMediaIndex = (parseInt(this.currentMediaIndex) - 1 + parseInt(this.mediaCount)) % this.mediaCount;

			if (this.media[this.currentMediaIndex].file_type === 'i') {
				this.loading = true;
				this.loadImage();
			}
		},
	};
}
